module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABI0lEQVQ4T42SMUrEQBSGv5lAWisFG1HwAJaeQFw8wZYBk0dAEUu3sNhCy0UQwiRi6wlkRTyAR9jOxUbQxr3ARCZMJGaz7k41M2++997871c0ljFmCzgHesCmD30AY2AkIu/1c1VvjDHHwBC41Vo/xHH85mJZlm0HQdAvy/IUuBSRO3dfgR46A47qrMaYAxF5biR23TwCNw5Wvr1XYL/ZijFmGobhXhRF3y24euvAkVLqM0mS69Z/50Df3QBYd+DEWnuYpul0FbAoih1r7diBMxFZa0I+c2dFH5v9B74Au7/yKzVMkuS+CU601r1a/nbl9tmNR2v9VIkDfInI1TLIxfM8vyjLcmPhOLqSNEe30AAdYv01wDLLefn7wMmc5VrOWMnkPxHYn1PUxoVdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/alarm_clock@2x.png
// module id = misi
// module chunks = 19